<template>
  <div class="body">
    <div class="remove">
      <van-image
        @click="remove"
        :src="require('../../../../../../public/image/13/02/7.png')"
      ></van-image>
    </div>
    <div class="dialogWarp">
      <div class="warp">
        <van-image
          class="headerImage"
          :src="require('../../../../../../public/image/13/05/1.png')"
        ></van-image>

        <div class="jlImage">
          <van-image
            :src="require('../../../../../../public/image/13/05/2.png')"
          ></van-image>
        </div>
        <div class="jdImage">
          <van-image
            @click="clickMe"
            :src="require('../../../../../../public/image/13/05/3.png')"
          ></van-image>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import getData from '../../../../../../utils/request/request'
import { Toast } from 'vant'
import getButton from '../../../../../../utils/getButton'

export default {
  props: {
    isActivity: Boolean
  },
  created() {
    this.$emit(
      'changeBackgroundImage',
      require('../../../../../../public/image/13/02/1.png')
    )
  },
  methods: {
    clickMe() {
      if (this.isActivity) {
        getButton('預約頁-職業選擇彈窗-立即選擇')
      } else {
        getButton('版頭-職業選擇彈窗-立即選擇')
      }
      this.$emit('removeClick', false)
      this.$emit('scrollIntoView', '#Activity03')
    },
    remove() {
      this.$emit('removeClick', false)
    }
  }
}
</script>

<style lang="scss" scoped>
@keyframes heartbeat {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
  }
}
.body {
  width: 100%;
  padding: 10px;
  height: 100%;
  box-sizing: border-box;
  position: relative;
  .remove {
    position: absolute;
    top: 10px;
    right: 10px;
    width: 15px;
  }
  .dialogWarp {
    position: relative;
    width: 100%;
    height: 100%;
    .warp {
      .headerImage {
        width: 60%;
        display: block;
        margin: 0 auto;
        margin-top: 20px;
      }
      .buttonwarp {
        /deep/ .van-image {
          animation: heartbeat 1s ease infinite;
          display: block;
          width: 60%;
          margin: 0 auto;
          margin-top: 20px;
        }
      }
      .jlImage {
        margin-top: 10px;
      }
      .jdImage {
        /deep/ .van-image {
          animation: heartbeat 1s ease infinite;
          display: block;
          width: 70%;
          margin: 0 auto;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/route/src/prereg/components/faceDialog/page5/index.vue